import { fontType, toRem } from '../../styles/functions'
import styled from 'styled-components'
import { colors } from 'shared/styles/theme'

export const PageTitleWrapper = styled.h1`
	color: ${colors.darkGrey};
	font-size: ${toRem(24)};
	${fontType(-1)};
`
